export function getBearerToken() {
  return `Bearer ${localStorage.getItem('kvk-vb-token')}`
}
